import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {FixedRatioContainer} from '../../atoms/FixedRatioContainer/FixedRatioContainer';
import {Image} from '../../atoms/Image/Image';
import {Ratio} from '../../atoms/Image/types';

interface FullWidthImageProps {
  imageUrl?: string;
  description?: string;
  aspectRatio: Ratio;
  highPrioImage?: boolean;
  dataTestId?: string;
  className?: string;
  disableFixedRatio?: boolean;
  imagePosition?: string;
}

export const imageWidths = [440, 640, 860, 1080, 1300, 1560, 2000];
const breakpoints = [{columns: 1}];
export const initialBreakpoints = [
  {breakpoint: '(min-resolution: 4dppx)', columns: 4},
  {breakpoint: '(min-resolution: 3dppx)', columns: 3},
  {breakpoint: '(min-resolution: 2dppx)', columns: 2},
  {breakpoint: '(min-resolution: 1.5dppx)', columns: 1.5},
  {columns: 1},
];

export const FullWidthImage: FC<FullWidthImageProps> = ({
  imageUrl,
  description,
  aspectRatio,
  highPrioImage,
  dataTestId = 'fullScreenImage',
  className,
  disableFixedRatio,
  imagePosition = 'center',
}) => {
  return (
    <Wrapper className={className}>
      {imageUrl ? (
        <StyledImage
          data-testid={`${dataTestId}-image`}
          alt={description}
          src={imageUrl}
          ratio={aspectRatio}
          importance={highPrioImage ? 'high' : 'low'}
          loading={highPrioImage ? 'eager' : 'lazy'}
          initialBreakpoints={initialBreakpoints}
          breakpoints={breakpoints}
          widths={imageWidths}
          disableFixedRatio={disableFixedRatio}
          $imagePosition={imagePosition}
        />
      ) : (
        <FixedRatioContainer
          dataTestId={`${dataTestId}-placeholder`}
          ratio={aspectRatio}
        >
          <ImagePlaceholder />
        </FixedRatioContainer>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledImage = styled(Image)<{$imagePosition: string}>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: ${({$imagePosition: $impagePosition}) => $impagePosition};
`;

const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
`;
